export namespace Utils {
    export function removeWhitespace(val: string): string {
        return val.replace(/\s/g, '');
    }

    export function trim(val: string): string {
        return val.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    export function onlyNumeric(st: string) {
        return st.replace(/[^0-9]/gi, '');
    }

    export function getBodyData(name: string): string {
        if (document.body.dataset) {
            return document.body.dataset[name];
        } else {
            return document.body.getAttribute(`data-${name}`);
        }
    }

    export function validateEmail(email: string): boolean {
        let re: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(Utils.trim(email));
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/Utils.ts